export default "__VITE_ASSET__DtnGqhgv__"